// extracted by mini-css-extract-plugin
export default {"option":"Update_option__k3pIx","ans":"Update_ans__Vq7aI","checkbox":"Update_checkbox__eBWYR","ques":"Update_ques__WpP-e"};